import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const addTagsToChat = createAsyncThunk(
  'chatTags/addTagsToChat',
  async ({ room_id, tag_ids, business_id }, { getState, rejectWithValue }) => {
    if (!room_id) {
      return rejectWithValue({ message: 'Missing chat room id' });
    }
    if (!business_id) {
      return rejectWithValue({ message: 'Missing business id' });
    }

    try {
      const { loginToken, loginTokenCoUser } = getState();
      const authToken =
        loginToken?.response?.token || loginTokenCoUser?.response?.token;

      const response = await axios.put(
        `${ROOT_URL}/tags/conversation/chat-room/${encodeURIComponent(room_id)}`,
        {
          business_id,
          tag_ids: Array.isArray(tag_ids) ? tag_ids : [],
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message },
      );
    }
  },
);

const initialState = {
  loading: false,
  error: null,
  success: false
};

const addTagsToChatSlice = createSlice({
  name: 'addTagsToChat',
  initialState,
  reducers: {
    resetAddTagsToChat: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addTagsToChat.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addTagsToChat.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(addTagsToChat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }
});

export const { resetAddTagsToChat } = addTagsToChatSlice.actions;
export default addTagsToChatSlice.reducer; 